import { Box, Button, Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import { getAuth } from 'firebase/auth';
import { FunctionComponent, useEffect } from 'react';
import arrowRight from '../../../assets/svgs/arrow-right.svg';
import { PageContainer } from '../../../components/PageContainer';
import { TopBar } from '../../../components/TopBar';
import { CONNECT_SCREENS } from '../../../constants';
import { Analytics } from '../../../helpers/analytics/Analytics';
import { AnalyticsEventName } from '../../../helpers/analytics/AnalyticsEvent';
import { useAuthDispatch, useAuthStore } from '../../../store/AuthStore';
import { ActionType, ConnectInitializeUser } from '../../../store/StoreTypes';

const useStyles = makeStyles({
  cardRoot: {
    height: '100%',
    padding: '25px 25px',
    width: 'max-content',
  },
  headingFont: { fontFamily: 'CircularXX-Book, sans-serif', fontWeight: 700 },
});

export const MyAccount: FunctionComponent = () => {
  const classes = useStyles();

  const {
    name: firstName,
    lastName,
    email,
    profession,
  } = useAuthStore((state) => state.user as ConnectInitializeUser) ?? {};
  const dispatch = useAuthDispatch();

  useEffect(function trackAnalytics() {
    Analytics.track({
      event: AnalyticsEventName.h_screen_viewed,
      screen: CONNECT_SCREENS.MY_ACCOUNT,
    });
  }, []);

  async function logoutClicked() {
    dispatch({ type: ActionType.CLEAR_USER });
    await getAuth().signOut();
  }

  return (
    <PageContainer testId="my-account-screen">
      <TopBar title={`${firstName} ${lastName}`} description="My Account" />

      <Card elevation={1} classes={{ root: classes.cardRoot }}>
        <CardContent>
          <Box display="flex" paddingBottom="15px">
            <Typography>
              <span className={classes.headingFont}>Email: </span>
              {email}
            </Typography>
          </Box>
          <Box display="flex">
            <Typography>
              <span className={classes.headingFont}>Profession: </span>
              {profession === 'Dietician' ? 'Dietitian' : profession}
            </Typography>
          </Box>
          <Box width="200px" display="flex" position="relative" paddingTop="40px">
            <Button
              type="button"
              onClick={logoutClicked}
              variant="contained"
              color="primary"
              size="small"
              fullWidth
              endIcon={<img src={arrowRight} alt="logout button" width="20px" height="20px" />}
            >
              Log out
            </Button>
          </Box>
        </CardContent>
      </Card>
    </PageContainer>
  );
};
